export const consentTypes = ['DATA_PROCESSING_AND_OFFERS', 'PROJECT_PARTICIPATION', 'CLIENT_DATA_PROCESSING'] as const;
export type ConsentType = (typeof consentTypes)[number];
export const consentTypeMap: Record<ConsentType, string> = {
  DATA_PROCESSING_AND_OFFERS: 'Data Processing and Offers',
  PROJECT_PARTICIPATION: 'Project Participation',
  CLIENT_DATA_PROCESSING: 'Client Data Processing',
};

export type ConsentTemplate = {
  id: number;
  version: number;
  type: ConsentType;
  content: string;
  englishContent: string | null;
  createdDate: string;
  createdBy: { id: number; firstName: string; lastName: string } | null;
};

export type CandidateConsentStatus = 'PENDING_APPROVAL' | 'APPROVED' | 'RENEWED' | 'REVOKED' | 'EXPIRED';
export const nextCandidateConsentStatuses: Record<CandidateConsentStatus, CandidateConsentStatus[]> = {
  PENDING_APPROVAL: ['APPROVED', 'REVOKED'],
  APPROVED: ['REVOKED'],
  RENEWED: ['REVOKED'],
  REVOKED: ['RENEWED'],
  EXPIRED: ['RENEWED'],
};

export type CandidateConsent = {
  id: number;
  originalId: number;
  type: ConsentType;
  status: CandidateConsentStatus;
  expiryDate: string | null;
  template: ConsentTemplate;
  createdDate: string;
  createdBy: {
    id: number;
    firstName: string;
    lastName: string;
  } | null;
  client?: {
    uuid: string;
    name: string;
  };
  project?: {
    uuid: string;
    name: string;
  };
};
